// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import type { IconProp } from '@crehana/ui';

export enum InfoDialogTypeEnum {
  Back = '_BACK',
  Delete = '_DELETE',
  Download = '_DOWNLOAD',
  Email = '_EMAIL',
  Error = '_ERROR',
  Info = '_INFO',
  Success = '_SUCCESS',
  Pause = '_PAUSE',
  Resume = '_RESUME',
}

/**
 * This type allows you to know what kind of dialog is being dismissed/confirmed when calling onDismiss and onConfirm, without needing direct access to the dialog state.
 */
type InfoDialogEventType = (affectedDialogType: InfoDialogTypeEnum) => void;

interface InfoDialogEventProps {
  onDismiss: InfoDialogEventType;
  onConfirm?: InfoDialogEventType;
}

export interface InfoDialogOptionProps {
  type: InfoDialogTypeEnum;
  title: string;
  description: string | JSX.Element;
  descriptionRight?: string | JSX.Element | null;
  icon?: IconProp;
  headerImage?: string;
  buttonLabel?: string;
}

export interface InfoDialogProps
  extends InfoDialogEventProps,
    InfoDialogOptionProps {
  open: boolean;
}
